module.exports = __webpack_public_path__ + "media/images/top/common/img_feature02-b04718c7561c198b5be1c2f49a305eb2.png";